var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm._l(_vm.itemServices, function (itemService, itemServiceIndex) {
        return _c(
          "div",
          { key: itemService.id, staticClass: "card-section hover" },
          [
            _c(
              "div",
              {
                staticClass: "title",
                class:
                  _vm.highlightDeleteChange(itemService.addendumLabel) ||
                  _vm.highlightNonDeleteTitleChange(
                    itemService,
                    itemServiceIndex
                  ),
              },
              [_vm._v("\n      " + _vm._s(itemService.title) + "\n    ")]
            ),
            _vm._v(" "),
            itemService.sectionDesc
              ? _c(
                  "div",
                  {
                    staticClass: "description",
                    class:
                      _vm.highlightDeleteChange(itemService.addendumLabel) ||
                      _vm.highlightNonDeleteChange(itemService.addendumLabel),
                  },
                  [
                    _c("pre", [
                      _c("p", [_vm._v(_vm._s(itemService.sectionDesc || ""))]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("table", [
              _c("thead", [
                _c("th", { staticClass: "number" }, [
                  _vm._v("\n          #\n        "),
                ]),
                _vm._v(" "),
                _c("th", { staticStyle: { "padding-left": "0" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.section.descOfWork")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "qty-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.section.qty")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "unit-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.section.unit")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(itemService.lineItems, function (item, index) {
                    return [
                      _c(
                        "tr",
                        {
                          key: item.id,
                          staticClass: "set-border-top",
                          class:
                            _vm.highlightDeleteChange(
                              itemService.addendumLabel,
                              item.addendumLabel
                            ) ||
                            _vm.highlightNonDeleteLineChange(
                              item,
                              itemServiceIndex,
                              index
                            ),
                          style: _vm.setBackgroundColor(index),
                        },
                        [
                          _c("td", { staticClass: "number" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.itemNo) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "desc-of-work-text" }, [
                            _c("pre", { staticClass: "none-x-scroll" }, [
                              _c("p", [_vm._v(_vm._s(item.itemDesc))]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "qty-text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.itemQty) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "unit-text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.itemUnit) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(item.options, function (option, optionIndex) {
                        return _c(
                          "tr",
                          {
                            key: optionIndex,
                            class:
                              _vm.highlightDeleteChange(
                                itemService.addendumLabel,
                                item.addendumLabel,
                                option.addendumLabel
                              ) ||
                              _vm.highlightNonDeleteChange(
                                option.addendumLabel
                              ),
                            style: _vm.setBackgroundColor(index),
                          },
                          [
                            _c("td"),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "option-desc",
                                style: _vm.setPaddingBottom(
                                  optionIndex,
                                  item.options
                                ),
                              },
                              [
                                _c("pre", [
                                  _c("p", [_vm._v(_vm._s(option.optionDesc))]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "qty-text",
                                style: _vm.setPaddingBottom(
                                  optionIndex,
                                  item.options
                                ),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.optionQty) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "unit-text",
                                style: _vm.setPaddingBottom(
                                  optionIndex,
                                  item.options
                                ),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.optionUnit) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.showOthersForEngineer
        ? _c("div", { staticClass: "row card-section hover" }, [
            _c("input", {
              staticClass: "section-others-checkbox",
              attrs: { type: "checkbox", disabled: "" },
              domProps: { checked: _vm.allowServiceAddOthers },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "title",
                class: _vm.highlightAllowServiceAddOthers,
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("tender.section.unExternalOthers")) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }